import { useQuery } from "@tanstack/react-query";
import { FOUNDING_RATES_QUERY_KEY } from "./constants";
import { fetchFoundingRates } from "./founding-api";

/**
 * The configured founding-discount defaults (ADR-0010 §9), used to pre-fill the
 * assign dialog's intro/ongoing inputs.
 *
 * `enabled` gates the fetch to when the dialog is actually open, so a closed
 * dialog never triggers a request. The read is ADMIN + FINANCE; the assign
 * dialog only mounts for ADMIN mutators, so no extra role gating is needed. The
 * defaults change rarely, hence a 5-minute `staleTime`.
 */
export function useFoundingRates(enabled = true) {
  return useQuery({
    queryKey: FOUNDING_RATES_QUERY_KEY,
    queryFn: fetchFoundingRates,
    enabled,
    staleTime: 5 * 60_000,
  });
}
